import { useState, useEffect } from 'react';
import { departmentService } from '../../shared/utils/serviceProvider';

export const useDepartmentData = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const mapApiDataToDepartment = (dept) => ({
    id: dept.id,
    name: dept.name,
    code: dept.code,
    description: dept.description,
    managerId: dept.managerId || dept.manager_id,
    manager: dept.manager || dept.managerId || dept.manager_id,
    employeeCount: dept.employeeCount || dept.employee_count || 0,
    employeeCapacity: dept.employeeCapacity || dept.employee_capacity || 0,
    budget: dept.budget || 0,
    budgetUsed: dept.budgetUsed || dept.budget_used || 0,
    location: dept.location || '',
    email: dept.email || '',
    phone: dept.phone || '',
    establishedDate: dept.establishedDate || dept.established_date || '',
    status: dept.status || 'active',
    notes: dept.notes || '',
    createdAt: dept.createdAt || dept.created_at,
    updatedAt: dept.updatedAt || dept.updated_at
  });

  const refreshDepartments = async () => {
    const data = await departmentService.getDepartments();
    if (Array.isArray(data)) {
      const formattedDepartments = data.map(mapApiDataToDepartment);
      setDepartments(formattedDepartments);
      return formattedDepartments;
    } else {
      console.log('No departments found or invalid data format');
      setDepartments([]);
      return [];
    }
  };

  useEffect(() => {
    const loadDepartments = async () => {
      try {
        setLoading(true);
        const departments = await refreshDepartments();
        console.log(`Loaded ${departments.length} departments from database`);
      } catch (err) {
        setError(err);
        console.error('Error loading departments:', err);
        setDepartments([]);
      } finally {
        setLoading(false);
      }
    };
    
    loadDepartments();
  }, []);

  const addDepartment = async (department) => {
    try {
      const newDepartment = await departmentService.createDepartment(department);
      await refreshDepartments();
      return newDepartment;
    } catch (err) {
      setError(err);
      console.error('Error adding department:', err);
      throw err;
    }
  };

  const updateDepartment = async (id, updatedData) => {
    try {
      const updated = await departmentService.updateDepartment(id, updatedData);
      await refreshDepartments();
      return updated;
    } catch (err) {
      setError(err);
      console.error('Error updating department:', err);
      throw err;
    }
  };
  
  const deleteDepartment = async (id) => {
    try {
      await departmentService.deleteDepartment(id);
      await refreshDepartments();
    } catch (err) {
      setError(err);
      console.error('Error deleting department:', err);
      throw err;
    }
  };
  
  const getDepartmentById = (id) => {
    return departments.find(dept => dept.id === id || dept.id === parseInt(id));
  };

  return { 
    departments, 
    loading, 
    error, 
    addDepartment, 
    updateDepartment,
    deleteDepartment,
    getDepartmentById,
    refreshDepartments
  };
};

